"use client";

import { useState } from "react";
import { ShoppingBag, Check } from "lucide-react";
import { cn } from "@/lib/cn";

type Props = {
  disabled?: boolean;
  onAdd?: () => void;
  className?: string;
};

// Phase 2 visual stub. At Shopify time, swap the internal handler for a
// cartLinesAdd mutation call against the Shopify cart ID.
export default function AddToCartButton({ disabled, onAdd, className }: Props) {
  const [added, setAdded] = useState(false);

  const handle = () => {
    if (disabled) return;
    onAdd?.();
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={handle}
      className={cn(
        "inline-flex h-12 items-center justify-center gap-2 rounded-[var(--radius-md)] bg-[color:var(--color-primary)] px-6 text-sm font-medium text-white transition-colors hover:bg-[color:var(--color-primary-dark)] disabled:opacity-50 disabled:cursor-not-allowed",
        className,
      )}
      aria-live="polite"
    >
      {added ? (
        <>
          <Check size={18} />
          Added to basket
        </>
      ) : (
        <>
          <ShoppingBag size={18} />
          {disabled ? "Out of stock" : "Add to basket"}
        </>
      )}
    </button>
  );
}
